import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { uniqueId } from 'lodash';
import { IconSize } from './dtos/icon-size.dto';

@Component({
  selector: 'aprova-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  standalone: true,
  host: {
    '[style.width]': 'getIconSizeVar()',
    '[style.height]': 'getIconSizeVar()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  @Input()
  public id: string = uniqueId('aprova-icon-');

  @Input()
  public name: string = '';

  @Input()
  public color: string = 'currentColor';

  @Input()
  public size: IconSize | string = 'lg';

  protected getIconSizeVar(): string {
    const sizeMap: Record<IconSize, string> = {
      'xs': '12px',
      'sm': '16px',
      'md': '20px',
      'lg': '24px',
      'xl': '36px',
      '2xl': '40px',
    };

    if (this.size in sizeMap) {
      return sizeMap[this.size as IconSize];
    }

    return this.size;
  }
}
